let timeout

export function onLoad() {
  console.log('home code loaded')
  // TODO:: homepage animation
}
